import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.sass'],
})
export class PaginationComponent implements OnInit {
  @Input() range: any[];
  @Input() currentPage: number;
  @Output() onPageLinkClick = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  pageLinkClick(event, page) {
    event.preventDefault();
    this.onPageLinkClick.emit(page);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pagination/pagination.component.ts